import { t } from "i18next";
export const AIRPORT_IATA_MAPPER = {
    OSL: t("airportIata.osl"),
    BGO: t("airportIata.bgo"),
    SVG: t("airportIata.svg"),
    TRD: t("airportIata.trd"),
};
export const mapAirportIataToName = (iata) => {
    return AIRPORT_IATA_MAPPER[iata];
};
